<template>
  <div v-if="settings">
    <div class="full-view" v-if="settings.identityProvider == 'LOCAL'"
         :style="'background-image: url(\'' + settings.loginBackground + '\')'"
    >
      <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
        <div class="login-form">
          <div v-if="loggedIn">Logged in.
            <mdb-spinner/>
          </div>
          <div v-if="!loggedIn && checkingToken">
            <mdb-spinner/>
          </div>

          <div v-if="!loggedIn && tokenValid">
            <mdb-card style="width:100%">
              <mdb-card-header>
                <p class="h5">Reset Your Password</p>
              </mdb-card-header>
              <mdb-card-body>
                <mdb-input id="new-password" v-model="newPassword" label="New Password" required type="password"/>
                <mdb-input v-model="newPasswordConfirm" label="Confirm" required type="password"/>
                <div v-if="newPassword!=newPasswordConfirm || newPassword.length<6" class="text-danger">Passwords must match
                  and be at least 6 characters long.
                </div>
                <mdb-btn :disabled="newPassword!=newPasswordConfirm || newPassword.length<6" @click="savePassword">
                  <mdb-icon icon="save"/>
                  Save
                </mdb-btn>
              </mdb-card-body>
            </mdb-card>
          </div>

          <div v-if="!loggedIn && !tokenValid">
            <mdb-card style="width:100%">
              <mdb-card-header>
                <p class="h5">Ooops!</p>
              </mdb-card-header>
              <mdb-card-body>
                Link is not valid. You may only use a change password link once.
              </mdb-card-body>
            </mdb-card>
          </div>


        </div>
      </mdb-mask>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import api from "../services/groupsPlaceApi";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbSpinner,
  mdbView
} from 'mdbvue';

export default {
  name: 'Login',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbSpinner,
    mdbMask,
    mdbView,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter
  },
  computed: mapState({
                       apiKey: state => state.apiKey,
                       userDetails: state => state.userDetails,
                       loggedIn: state => state.loggedIn,
                       settings: state => state.settings
                     }),
  data() {
    return {
      checkingToken: false,
      tokenValid: false,
      newPassword: "",
      newPasswordConfirm: ""
    }
  },
  mounted() {
    document.title = "Reset Password"
    if (this.loggedIn) {
      this.$router.push("/")
      return
    }
    this.checkingToken = true
    api.post("/user/tokenLogin", {token: this.$route.params.token}).then(
      (details) => {
        this.checkingToken = false
        this.tokenValid = details.data.valid
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 10000})
        this.showPasswordHelp = true
      })
  },
  methods: {
    savePassword() {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/tokenChangePassword", {token: this.$route.params.token, password: this.newPassword}).then(
        (details) => {
          api.completeLogin(details.data.authKey, details.data.secret, false)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 749px ) {
  .login-form {
    margin: auto;
    width: 80%;
  }
}

@media screen and (min-width: 750px ) {
  .login-form {
    margin: auto;
    width: 50%;
  }
}

.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}

.logo-top {
  max-width: 60%;
  margin: auto;
}

</style>
